<template>
  <div class="progress col-12 pl-0 pr-0 rounded" :class="{invisible: invisible === true}">
    <div class="progress-bar progress-bar-striped progress-bar-animated progress-bar-animated-indeterminate" role="progressbar" :class="{'progress-bar-striped': striped === true, 'progress-bar-animated': animated === true, 'progress-bar-animated-indeterminate': animatedIndeterminate === true}" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%"></div>
  </div>
</template>
<script>

export default {
  name: "ProgressBar",
  props: ["invisible", "striped", "animated", "animatedIndeterminate"],
  data() {
    return {
    }
  },
  mounted() {},
  computed: {},
  methods: {
  }

};
</script>
<style scoped>

.progress {
  height: 4px;
}

.progress .progress-bar-animated-indeterminate {
  animation: indeterminate 1.5s ease infinite;
  width: 30% !important;
}

@keyframes indeterminate {
  0% {
    margin-left: -50%;
  }
  100% {
    margin-left: 100%;
  }
}

</style>